<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :staticFilters="staticFilters"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :filters="filters"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      filters: [],
      staticFilters: [],
      val: [],
      modalCreate: "import",
      fields: [
        {
          col: " col-12 col-md-9",
          key: "phone",
          label: "Номер телефона",
          type: "mask",
          mask: "+998#########",
          placeholder: "+998",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_import",
      itemLink: "imports",
      setLink: "imports",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy: "id",
        },

        {
          key: "file",
          title: "Ссылка",
          link: true,
        },
        {
          key: "model",
          title: "Модель",
        },
        {
          align: "right",
          key: "created_at",

          dateTimeFormat: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
